import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CampaignsActions } from 'store/ducks/campaigns';

import { Access } from 'common';
import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Campaign/components';

class Edit extends Component {
  state = {
    data: {
      description: '',
      multiplier: '',
      start_at: null,
      end_at: null,
      extra_data: {
        store_channels: Access.lockedChannel() ? [Access.lockedChannel(true)] : [],
        store_channels_all: Access.lockedChannel() ? false : true,
        store_places: Access.lockedStore() ? [Access.lockedStore(true)] : [],
        store_places_all: Access.lockedStore() ? false : true,
        store_product_types: Access.lockedProductType() ? [Access.lockedProductType(true)] : [],
        store_product_types_all: Access.lockedProductType() ? false : true,
        store_sections: [],
        store_sections_all: true,
        store_sub_sections: Access.lockedSection() ? [Access.lockedSection(true)] : [],
        store_sub_sections_all: Access.lockedSection() ? false : true,
        remove_mdh: false,
        add_mdh: false,
        add_store_products: [],
        remove_store_products: [],
        send_email: false,
      },
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Campanha de Pontos', to: '/points/campaigns' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getCampaignRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { campaign } = this.props;

    if (oldProps.campaign.loading && !campaign.loading) {
      this.setState({
        data: {
          external_id: campaign.data.attributes.external_id,
          name: campaign.data.attributes.name,
          type_campaign: campaign.data.attributes.type_campaign,
          description: campaign.data.attributes.description,
          score: campaign.data.attributes.score,
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/points/campaigns/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.updateCampaignRequest(this.handleGetId(), {
      campaign_method: form,
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={update.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  campaign: state.campaigns.detail,
  update: state.campaigns.update,
});

const mapActions = dispatch => bindActionCreators(CampaignsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
